import { createEntity, fetchEntities, upsertEntity } from 'actions/entities';
import EntitiesList from 'components/entities/EntitiesList';
import HealthFundForm from 'components/superuser/health_funds/HealthFundForm'
import HealthFundsListItem from 'components/superuser/health_funds/HealthFundsListItem'
import { connect } from 'react-redux'

import { getHealthFunds } from 'selectors/health_funds'
import { Card } from 'semantic-ui-react'


const mapStateToProps = (state, ownProps) => {
  return {
    entities: getHealthFunds(state, ownProps),
    entityName: 'healthFund',
    item: HealthFundsListItem,
    form: HealthFundForm,
    listComponent: Card.Group,
    loading: state.meta.healthFund.loading,
    error: state.meta.healthFund.error
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('healthFunds'))
    },
    upsertEntity: (entityId) => {
      dispatch(upsertEntity('healthFund', entityId))
    },
    createEntity: () => {
      dispatch(createEntity('healthFund'))
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList);
